const initailState = {
  createAuctiondata: [],
  loading: false,
};

export function createAuctionReducer(state = initailState, { type, payload }) {
  switch (type) {
    case "CREATE_AUCTION":
      return { ...state, createAuctiondata: payload };
    case "SHOW_LOADING_OFFER":
      return { ...state, loading: true };
    case "HIDE_LOADING_OFFER":
      return { ...state, loading: false };
    default:
      return state;
  }
}


export const rescheduleAuctionReducer = (
  state = { auctionData: {}, auctionLoading: false },
  { type, payload }
) => {
  switch (type) {
    case "RESCHEDULE_AUCTION_FETCHING":
      return { ...state, auctionLoading: true };
    case "RESCHEDULE_AUCTION_SUCCESS":
      return { ...state, auctionData: payload, auctionLoading: false };
    case "CANNOT_RESCHEDULE_AUCTION":
      return { ...state, auctionLoading: false };

    default:
      return state;
  }
};